




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { BannerConfig, BannerType } from '../types';
import { windowHelper } from '@tencent/ppd-base-libs';
import LanuchWeapp from '@tencent/wphk-components-launch-weapp/src/LaunchWeapp.vue';
import { biClick } from '@tencent/fit-bi-sdk';
import { BI_TAGS } from '../constant';
import { isMiniAppJumpInfo } from '../business';

@Component({
  components: {
    LanuchWeapp,
  },
})
export default class BannerImage extends Vue {
  /** bannerData所在的下标 */
  @Prop({ default: 0 }) bannerIndex!: string;
  /** 单个banner数据 */
  @Prop() bannerData!: BannerConfig;
  /** banner类型 */
  @Prop() bannerType!: BannerType;
  /** 是否支持重复曝光上报 */
  @Prop({ default: true }) isMultBrow!: Boolean;

  /** 上报自定义参数 */
  get biParams() {
    return {
      // 支持多次曝光
      isMultBrow: this.isMultBrow,
    };
  }

  /** 拓展字段 */
  get biExt() {
    return {
      fbannertype: this.bannerType,
      fbannertag: this.bannerData.bannerTag,
    };
  }
  /** 是否渲染小程序标签 */
  get isRenderMiniAppTag(): boolean {
    // 只有平铺并且appId不为空时，才渲染小程序标签。
    // 如果是swiper，那么小程序标签在swiper-slide外部（解决swiper会吃掉点击事件的问题）
    return BannerType.tile === this.bannerType && isMiniAppJumpInfo(this.bannerData.bannerJumpInfo);
  }
  /**
   * 响应banner点击
   */
  handleBannerClick(bannerJumpUrl: string) {
    if (this.bannerType === BannerType.swiper || this.bannerType === BannerType.mpSwiper) {
      // 由外部swiper处理，点击事件绑定在swiper对象上
      // 绑定在img上的事件会被swiper吃掉，也就是说如果是swiper时，这个回调不一定会按预期执行
      return;
    }

    biClick(BI_TAGS.bc1, this.biExt);
    if (bannerJumpUrl) {
      windowHelper.redirect(bannerJumpUrl, 300);
    } else {
      // 如果没有配置跳转url（肯定也不会配置小程序），往外抛事件
      this.$emit('click', this.bannerIndex);
    }
  }
  /**
   * 点击小程序标签
   */
  handleMiniAppClick() {
    // 点击上报
    biClick(BI_TAGS.bc1, this.biExt);
  }
}
